import { render, staticRenderFns } from "./criteria-start-page.vue?vue&type=template&id=08fdd21c&scoped=true&"
import script from "./criteria-start-page.vue?vue&type=script&lang=ts&"
export * from "./criteria-start-page.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-start-page.vue?vue&type=style&index=0&id=08fdd21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fdd21c",
  null
  
)

export default component.exports